import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-479b6ef0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "form-wrap" }
const _hoisted_3 = { class: "form-block nongfu-field-placeholder-wrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", null, "设备检测情况说明")
], -1))
const _hoisted_5 = { class: "desc-textarea" }
const _hoisted_6 = { class: "form-wrap" }
const _hoisted_7 = { class: "form-block nongfu-field-placeholder-wrap" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", null, "设备情况附图")
], -1))

import { Toast } from 'vant'
import { useRoute, useRouter } from 'vue-router'
import { showToastLoading } from '@/utils/tools'
import { onMounted, Ref, ref, reactive } from 'vue'
import { getRepairOrderDetectInfo } from '@/apis/malfunction-repair'
import AppHeader from '@/components/Header.vue'
import CommonImagePreview from '@/components/CommonImagePreview.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'repair-order-detection',
  setup(__props) {

const $router = useRouter()
const $route = useRoute()

const guid = $route.query.guid as string
const imageGuids: Ref<string[]> = ref([])
let formData = reactive({
  repair_guid: guid, // 维修单guid
  remark: '', // 设备检测情况说明
  images: [],
  created_at: '', // 创建时间
})

async function initData() {
  showToastLoading()
  try {
    let data = await getRepairOrderDetectInfo(guid)
    console.log('data', data)
    formData.remark = data.remark
    imageGuids.value = data.images
    Toast.clear()
  } catch (error: any) {
    console.log('error', error)
    Toast(error.message || '网络错误')
  }
}
onMounted(() => {
  initData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "检测情况" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(formData).remark), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          (imageGuids.value.length > 0)
            ? (_openBlock(), _createBlock(CommonImagePreview, {
                key: 0,
                guids: imageGuids.value
              }, null, 8, ["guids"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}
}

})